import $ from 'jquery'
import { frame } from '../utilities'

export default function()
{
	const $promotionPopup = $('#promotion-popup')
	const $promotionPopupClose = $('#promotion-popup_close')

	const $promotionBar = $('#promotion-bar')
	const $body = $('body')

	function padBody()
	{
		if($promotionBar.hasClass('is-open'))
		{
			$body.css('padding-bottom', $promotionBar.height() + 'px')
		}
		else
		{
			$body.css('padding-bottom', '')
		}
	}

	function togglePopup(open=true)
	{
		$promotionPopup.toggleClass('is-closed', !open).toggleClass('is-open', open)
		$promotionBar.toggleClass('is-closed', open).toggleClass('is-open', !open)

		padBody()

		if(!open)
		{
			localStorage.notified = Date.now()
		}
	}

	togglePopup(!localStorage.notified)

	$(window).on('resize', e => frame(padBody))
	padBody()

	$promotionPopup.on('click', e =>
	{
		if(e.target === $promotionPopup[0])
		{
			togglePopup(false)
		}
	})

	$promotionPopupClose.on('click', e =>
	{
		e.preventDefault()
		togglePopup(false)
	})
}



// WEBPACK FOOTER //
// ./public/scripts/src/initializers/promotion.js